import { ROUTES } from "../constant/routes";
const cloudfrontBaseUrl = ROUTES.CLOUDFRONT_URL;
export const ErrorImg = `${cloudfrontBaseUrl}closecircle.webp`;
export const BataiyoLoader = `${cloudfrontBaseUrl}bataiyoloader.gif`;
export const YouTubeImg = `${cloudfrontBaseUrl}youtubesuccessicon.webp`;
export const XImg = `${cloudfrontBaseUrl}twittersuccessicon.webp`;
export const ReducesSearchTimeImg = `${cloudfrontBaseUrl}reducesearchtimeimg.svg`;
export const OrangeBulbIcon = `${cloudfrontBaseUrl}orangelightbulbicon.svg`;
export const OnlyTrustedImg = `${cloudfrontBaseUrl}onlytrustedimg.svg`;
export const NoCommissionImg = `${cloudfrontBaseUrl}nocommissionimg.svg`;
export const LinkedInImg = `${cloudfrontBaseUrl}linkedinsuccessicon.webp`;
export const LightBulbIcon = `${cloudfrontBaseUrl}lightbulbiconwhite.svg`;
export const InstagramImg = `${cloudfrontBaseUrl}instagramsuccessicon.webp`;
export const InfiniteGreenIcon = `${cloudfrontBaseUrl}infinitegreenicon.svg`;
export const HandsIcon = `${cloudfrontBaseUrl}handsicon.svg`;
export const FacebookImg = `${cloudfrontBaseUrl}facebooksuccessicon.webp`;
export const ConnectionIcon = `${cloudfrontBaseUrl}connectionicon.svg`;
export const BookIcon = `${cloudfrontBaseUrl}bookicon.svg`;
export const SupportingBusinessBlogCoverImg = `${cloudfrontBaseUrl}blogsupportinglocalbusinesses.webp`;
export const MovingToCityBlogCoverImg = `${cloudfrontBaseUrl}blogmovingtocity.webp`;
export const ModernDayBlogCoverImg = `${cloudfrontBaseUrl}blogmodernday.webp`;
export const DiscoveringBlogCoverImg = `${cloudfrontBaseUrl}blogdiscoveringchandigarh.webp`;
export const DigitalDivideBlogCoverImg = `${cloudfrontBaseUrl}blogdigitaldivideimg.webp`;
export const BataiyoLogoIcon = `${cloudfrontBaseUrl}bataiyoroadmapicon.svg`;
export const BataiyoLogo = `${cloudfrontBaseUrl}bataiyologo.webp`;
export const BataiyoFooterLogo = `${cloudfrontBaseUrl}bataiyofooterlogo.svg`;
export const IndiaFlagLogo = `${cloudfrontBaseUrl}flagofIndia.svg`;
export const DefaultServicesIcon = `${cloudfrontBaseUrl}homesettingicon.svg`;
export const PlayStoreImg = `${cloudfrontBaseUrl}playstore.svg`;
export const AppStoreImg = `${cloudfrontBaseUrl}appstore.svg`;
export const AppleIcon = `${cloudfrontBaseUrl}appleicon.webp`;
export const featureCrossImg = `${cloudfrontBaseUrl}bluecrossicons.webp`;
export const GoogleIcon = `${cloudfrontBaseUrl}googleicon.webp`;
export const QRCode = `${cloudfrontBaseUrl}qrcode.webp`;
export const NavLogo = `${cloudfrontBaseUrl}navlogo.svg`;
export const WhatsAppImg = `${cloudfrontBaseUrl}whatsappicon.webp`;
export const DashboardImg = `${cloudfrontBaseUrl}jobdashboardimg4.webp`;
export const HireCategoriesImg = `${cloudfrontBaseUrl}hirecategories.webp`;
export const JobAppImg = `${cloudfrontBaseUrl}jobappimg.webp`;
export const JobHeroImg = `${cloudfrontBaseUrl}jobheroframe4.webp`;
export const JobMobHeroImg = `${cloudfrontBaseUrl}heromobimg3.webp`;
export const SuccessDialogImg = `${cloudfrontBaseUrl}dialogsuccessimg.webp`;
export const WarningImg = `${cloudfrontBaseUrl}whitealert.webp`;
export const OurPlatformHiringImg = `${cloudfrontBaseUrl}ourplatformhireimg.svg`;
export const HeroSectionAppFrameMobImg = `${cloudfrontBaseUrl}hero-mob-frame-sm2.webp`;
export const HeroSectionAppFrameImg = `${cloudfrontBaseUrl}hero-mobile-frame-img4.webp`;
export const ExplorerSignupImg = `${cloudfrontBaseUrl}explorer-img.webp`;
export const ProviderSignupImg = `${cloudfrontBaseUrl}provider-img1.webp`;
export const HeroCheckIcon = `${cloudfrontBaseUrl}hero-check-icon.webp`;
export const PeerToPeerImg = `${cloudfrontBaseUrl}peer-to-peer-card-img1.webp`;
export const SuperAppCardImg = `${cloudfrontBaseUrl}super-app-card-img.webp`;
export const ZeroCommissionCardImg = `${cloudfrontBaseUrl}zero-commission-card-img2.webp`;
export const HotelOwner = `${cloudfrontBaseUrl}hotel-owner-profile.webp`;
export const GrowingTogetherIcon = `${cloudfrontBaseUrl}growing-together-icon.webp`;
export const CabProfile = `${cloudfrontBaseUrl}cab-profile.webp`;
export const NetworkMattersIcon = `${cloudfrontBaseUrl}networking-matters-icon.webp`;
export const DeliveryProfile = `${cloudfrontBaseUrl}delivery-profile.webp`;
export const RecommendationFriendImg = `${cloudfrontBaseUrl}recommended-friends-img.webp`;
export const RecommendationFriendMobImg = `${cloudfrontBaseUrl}recommended-friends-mob-img.webp`;
export const RecommendationTrustedTextImg = `${cloudfrontBaseUrl}recommended-trusted-text-img1.webp`;
export const RecommendationTrustedImg = `${cloudfrontBaseUrl}recommended-trusted-img2.webp`;
export const RecommendationTrustedLikeImg = `${cloudfrontBaseUrl}recommended-trusted-like-img.webp`;
export const RecommendationUserImg = `${cloudfrontBaseUrl}recommended-user-img.webp`;
export const RoadmapDotIcon = `${cloudfrontBaseUrl}roadmap-dot-img.webp`;
export const SuperAppAppStoreImg = `${cloudfrontBaseUrl}app-store-img.webp`;
export const SuperAppDownloadImg = `${cloudfrontBaseUrl}super-appmob-img.webp`;
export const SuperAppPlayStoreImg = `${cloudfrontBaseUrl}play-store-img.webp`;
export const TrustFirstIcon = `${cloudfrontBaseUrl}trust-first-icon.webp`;
export const AllServicesIcon = `${cloudfrontBaseUrl}all-services-icon.svg`;
export const SearchIcon = `${cloudfrontBaseUrl}search-normal-icon.png`;
export const PopularServicesIcon = `${cloudfrontBaseUrl}popular-services-icon.png`;
export const InstagramIconS = `${cloudfrontBaseUrl}instas-icon.svg`;
export const FacebookIconS = `${cloudfrontBaseUrl}fbs-icon.svg`;
export const LinkedInIconS = `${cloudfrontBaseUrl}linkedins-icon.svg`;
export const YouTubeIconS = `${cloudfrontBaseUrl}youtubes-icon.svg`;
export const XIconS = `${cloudfrontBaseUrl}xs-icon.svg`;
export const AppStoreS = `${cloudfrontBaseUrl}app-stores.svg`;
export const PlayStoreS = `${cloudfrontBaseUrl}play-stores.svg`;
export const RecommendationsMattersBlogCoverImg = `${cloudfrontBaseUrl}recommendation-matter-img.webp`;
export const AreWeLosingBlogCoverImg = `${cloudfrontBaseUrl}convenience-img.webp`;
export const GalleryImg1 = `${cloudfrontBaseUrl}gallery-1.jpg`;
export const GalleryImg2 = `${cloudfrontBaseUrl}gallery-2.webp`;
export const GalleryImg3 = `${cloudfrontBaseUrl}gallery-3.webp`;
export const GalleryImg4 = `${cloudfrontBaseUrl}gallery-4.webp`;
export const GalleryImg5 = `${cloudfrontBaseUrl}gallery-5.webp`;
export const GalleryImg6 = `${cloudfrontBaseUrl}gallery-6.webp`;
export const GalleryImg7 = `${cloudfrontBaseUrl}gallery-7.jpeg`;
export const GalleryImg8 = `${cloudfrontBaseUrl}gallery-8.jpeg`;
export const GalleryImg9 = `${cloudfrontBaseUrl}gallery-9.webp`;
export const GalleryImg10 = `${cloudfrontBaseUrl}gallery-10.webp`;
export const GalleryImg11 = `${cloudfrontBaseUrl}gallery-11.jpeg`;
export const GalleryImg12 = `${cloudfrontBaseUrl}gallery-12.webp`;
export const GalleryImg13 = `${cloudfrontBaseUrl}gallery-13.webp`;
export const GalleryImg14 = `${cloudfrontBaseUrl}gallery-14.webp`;
export const GalleryImg15 = `${cloudfrontBaseUrl}gallery-15.webp`;
export const GalleryImg16 = `${cloudfrontBaseUrl}gallery-16.webp`;
export const GalleryImg17 = `${cloudfrontBaseUrl}gallery-17.jpg`;
export const GalleryImg18 = `${cloudfrontBaseUrl}gallery-18.webp`;
export const GalleryImg19 = `${cloudfrontBaseUrl}gallery-19.webp`;
export const GalleryImg20 = `${cloudfrontBaseUrl}gallery-20.webp`;
export const GalleryImg21 = `${cloudfrontBaseUrl}gallery-21.webp`;
export const GalleryImg22 = `${cloudfrontBaseUrl}gallery-22.webp`;
export const GalleryImg23 = `${cloudfrontBaseUrl}gallery-23.webp`;
export const GalleryImg24 = `${cloudfrontBaseUrl}gallery-24.jpeg`;
export const GalleryImg25 = `${cloudfrontBaseUrl}gallery-25.jpeg`;
export const GalleryImg26 = `${cloudfrontBaseUrl}gallery-26.jpeg`;
export const GalleryImg27 = `${cloudfrontBaseUrl}gallery-27.jpeg`;
export const GalleryImg28 = `${cloudfrontBaseUrl}gallery-28.jpeg`;
export const GalleryImg29 = `${cloudfrontBaseUrl}gallery-29.jpeg`;
export const GalleryImg30 = `${cloudfrontBaseUrl}gallery-30.jpeg`;
export const GalleryImg31 = `${cloudfrontBaseUrl}gallery-31.jpeg`;
export const GalleryImg32 = `${cloudfrontBaseUrl}gallery-32.jpeg`;
export const GalleryImg33 = `${cloudfrontBaseUrl}gallery-33.jpeg`;
export const GalleryImg34 = `${cloudfrontBaseUrl}gallery-34.jpeg`;
export const GalleryImg35 = `${cloudfrontBaseUrl}gallery-35.webp`;
export const GalleryImg36 = `${cloudfrontBaseUrl}gallery-36.webp`;
export const GalleryImg37 = `${cloudfrontBaseUrl}gallery-37.jpg`;
export const GalleryImg38 = `${cloudfrontBaseUrl}gallery-38.jpg`;
export const GalleryImg39 = `${cloudfrontBaseUrl}gallery-39.jpg`;
export const GalleryImg40 = `${cloudfrontBaseUrl}gallery-40.jpg`;
export const GalleryImg41 = `${cloudfrontBaseUrl}gallery-41.jpg`;
export const GalleryImg42 = `${cloudfrontBaseUrl}gallery-42.jpg`;
export const GalleryImg43 = `${cloudfrontBaseUrl}gallery-43.webp`;
export const GalleryImg44 = `${cloudfrontBaseUrl}gallery-44.webp`;
export const GalleryImg45 = `${cloudfrontBaseUrl}gallery-45.webp`;
export const GalleryImg46 = `${cloudfrontBaseUrl}gallery-46.webp`;
export const GalleryImg47 = `${cloudfrontBaseUrl}gallery-47.webp`;
export const GalleryImg48 = `${cloudfrontBaseUrl}gallery-48.webp`;
export const GalleryImg49 = `${cloudfrontBaseUrl}gallery-49.webp`;
export const GalleryImg50 = `${cloudfrontBaseUrl}gallery-50.webp`;
export const GalleryImg51 = `${cloudfrontBaseUrl}gallery-51.webp`;
export const GalleryImg52 = `${cloudfrontBaseUrl}gallery-52.jpg`;
export const GalleryImg53 = `${cloudfrontBaseUrl}gallery-53.jpg`;
export const AboutUsHeroImg = `${cloudfrontBaseUrl}about-hero-img.png`;
export const NewsImg = `${cloudfrontBaseUrl}news-img.png`;
export const StatsLogo = `${cloudfrontBaseUrl}stats-logo.png`;
export const StatsSmLogo = `${cloudfrontBaseUrl}stats-sm-logo.png`;
export const TeamMemberImg1 = `${cloudfrontBaseUrl}jitender-img1.png`;
export const TeamMemberImg2 = `${cloudfrontBaseUrl}dhanik-img1.png`;
export const ANINewsImg = `${cloudfrontBaseUrl}ani-news-logo.png`;
export const BusinessStandardNewsImg = `${cloudfrontBaseUrl}business-standard-news-logo.png`;
export const ThePrintNewsImg = `${cloudfrontBaseUrl}the-print-news-logo.png`;
export const LatestLyNewsImg = `${cloudfrontBaseUrl}latestly-news-logo.jpeg`;
export const UNINewsImg = `${cloudfrontBaseUrl}uni-news-logo.png`;
export const WebIndia123Img = `${cloudfrontBaseUrl}web-india-123-news-logo.jpeg`;
export const BigNewsImg = `${cloudfrontBaseUrl}big-news-network-news-logo.jpeg`;
export const DailyHuntNewsImg = `${cloudfrontBaseUrl}daily-hunt-news-logo.png`;
export const JioNewsImg = `${cloudfrontBaseUrl}jio-news-logo.png`;
export const TeamsLinkedIn = `${cloudfrontBaseUrl}about-linkedin-img.png`;
export const AsianNewsImg = `${cloudfrontBaseUrl}asian-news-logo.png`;
export const Up18NewsImg = `${cloudfrontBaseUrl}up18-news-network-news-logo.jpeg`;
export const SamacharSansaarImg = `${cloudfrontBaseUrl}samacharsansaar-news-logo.png`;
export const RepublicNewsTodayImg = `${cloudfrontBaseUrl}republicnewstoday-news-logo.png`;
export const TheNewsCartelImg = `${cloudfrontBaseUrl}thenewscartel-news-logo.png`;
export const StartupReporterImg = `${cloudfrontBaseUrl}startupreporter-news-logo.png`;
export const TheIndianAlert = `${cloudfrontBaseUrl}theindianalert-news-logo.jpeg`;
export const MumbaiTimesImg = `${cloudfrontBaseUrl}mumbaitimes-news-logo.png`;
export const BharatScoopsImg = `${cloudfrontBaseUrl}bharatscoops-news-logo.png`;
export const FinancialNewsDay = `${cloudfrontBaseUrl}financialnewsday-news-logo.png`;
export const NewsTrendDaily = `${cloudfrontBaseUrl}newstrenddaily-news-logo.png`;
export const NewsWireIndia = `${cloudfrontBaseUrl}newswireindia-news-logo.png`;
export const RTNews24 = `${cloudfrontBaseUrl}rtnews24-news-logo.png`;
export const BizNews = `${cloudfrontBaseUrl}biznews-news-logo.png`;
export const VentureCompanyNews = `${cloudfrontBaseUrl}venturecompanynews-news-logo.jpeg`;
export const WorldNewsForAll = `${cloudfrontBaseUrl}worldnewsforall-news-logo.jpeg`;
export const IndianBusinessLine = `${cloudfrontBaseUrl}indianbusinessline-news-logo.jpeg`;
export const NewIndiaHerald = `${cloudfrontBaseUrl}newindiaherald-news-logo.png`;
export const Republic21 = `${cloudfrontBaseUrl}republic21-news-logo.png`;
export const TribuneIndia = `${cloudfrontBaseUrl}tribuneindia-news-logo.jpeg`;
